<template>
  <el-dialog :visible.sync="isModalVisible" :show-close="false" :close-on-click-modal="false" width="68%">
    <span slot="title" class="font-weight-bold h4">
      <div class="d-flex justify-content-between">
        <span> Add Order Numbers </span>
      </div>
    </span>
    <div class="pl-1 pt-2" style="margin-top: -20px !important">
      <span class="h6"> Add order numbers below for each line item or group of items in the order. </span>
      <br />
      <span class="h6">
        Confirming the order will send an email notification to the buyer. You also can include an optional message
        using the form below.
      </span>
    </div>
    <el-row class="py-4">
      <el-row v-if="isGenerateOrderNumbersEnabled && !isBunkering" class="pb-3">
        <el-col :span="3" class="mt-2 font-weight-bold text-t_blue">
          {{ selectedOffers.length }} {{ selectedOffers.length === 1 ? "item" : "items" }} Selected
        </el-col>
        <el-col :span="6">
          <el-button class="btn btn-actionable" @click="generateReleaseNumber" :disabled="!selectedOffers.length">
            {{ selectedOffers.length > 0 ? "Generate Release No." : "Select Orders to Generate Release Number" }}
          </el-button>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form ref="form" :model="{ getOffers }" label-position="top">
          <el-table ref="table" :data="getOffers" :fit="true" size="mini" :header-cell-class-name="tableHeaderClass">
            <el-table-column width="55" v-if="!isBunkering">
              <template slot="header">
                <span :key="renderKey">
                  <input type="checkbox" v-model="selectAll" @input="toggleSelection" />
                </span>
              </template>
              <template slot-scope="scope">
                <input type="checkbox" v-model="selectedOffers" :value="scope.row.orderId" />
              </template>
            </el-table-column>
            <el-table-column align="left" label="Product" min-width="100px">
              <template slot-scope="scope">
                <span>{{ scope.row.fuel }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Vol/L" min-width="100px">
              <template slot-scope="scope">
                <span>{{ scope.row.quantity }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Contract No." min-width="100px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="'getOffers.' + scope.$index + '.contractNumber'"
                  class="pt-3 pb-2"
                  :rules="isGenerateOrderNumbersEnabled ? formRules.contractNumber : {}"
                >
                  <el-input :disabled="isGenerateOrderNumbersEnabled" v-model="scope.row.contractNumber"> </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Release No." min-width="100px" v-if="!isBunkering">
              <template slot-scope="scope">
                <el-form-item
                  :prop="'getOffers.' + scope.$index + '.releaseNumber'"
                  class="pt-3 pb-2"
                  :rules="isGenerateOrderNumbersEnabled ? formRules.releaseNumber : {}"
                >
                  <el-input :disabled="isGenerateOrderNumbersEnabled" v-model="scope.row.releaseNumber"> </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Movement No." min-width="100px" v-if="!isBunkering">
              <template slot-scope="scope">
                <el-form-item class="pt-3 pb-2">
                  <el-input v-model="scope.row.movementNumber"> </el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="pt-2">
      <span class="font-weight-bold"> Optional Message </span>
    </el-row>
    <el-row type="flex" justify="center" class="pt-2">
      <el-col :span="24" class="text-center">
        <el-input type="textarea" :rows="6" placeholder="Enter message.." v-model="customerFeedback"> </el-input>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer-center">
      <div v-if="errorMessageOnSave" class="d-block text-t_red mb-3 error">
        <b>{{ errorMessageOnSave }}</b>
      </div>
      <el-row :gutter="20">
        <el-button size="small" class="btn btn-neutral" @click="cancelSave">
          {{ isComingFromOrderCapture ? "Close" : "Back" }}</el-button
        >
        <el-button
          size="small"
          class="btn btn-confirm"
          @click="confirmSave"
          :loading="btnLoading"
          :disabled="errorMessageOnSave"
          >Confirm Order</el-button
        >
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import breakpoint from "@/mixins/index";
import { updateOrderStatus, updateOrderNumbers } from "@/api/orders";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
export default {
  components: {},
  mixins: [breakpoint],
  props: {
    orderId: {
      type: String,
      required: true,
      default: "",
    },
    orderToUpdate: {
      type: Array,
      required: true,
      default: () => [],
    },
    isBunkering: {
      type: Boolean,
      required: false,
      default: true,
    },
    viewManageOrderNumbersDialog: {
      type: Boolean,
      required: false,
      default: true,
    },
    isComingFromOrderCapture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedOffers() {
      if (!this.selectedOffers.length || this.selectedOffers.length !== this.orderData.length) {
        this.selectAll = false;
        this.renderKey++;
      } else if (this.selectedOffers.length === this.orderData.length) {
        this.selectAll = true;
        this.renderKey++;
      }
    },
    showItemRemovalConfirmation() {
      if (!this.showItemRemovalConfirmation) {
        this.isModalVisible = true;
        this.$emit("update:viewEditOrderDialogVisible", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
    unsavedChangesRemovalConfirmed() {
      if (this.unsavedChangesRemovalConfirmed) {
        this.$emit("update:viewManageOrderNumbersDialog", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
  },
  data() {
    const validateContractInput = (rule, value, callback) => {
      if (this.isGenerateOrderNumbersEnabled) {
        if (value == null || !value.trim()) {
          callback(new Error("Required"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      renderKey: 0,
      selectAll: false,
      selectedOffers: [],
      unmodifiedOrderData: null,
      isConfirmingOrder: true,
      customerFeedback: "",
      orderData: null,
      btnLoading: false,
      isModalVisible: true,
      errorMessageOnSave: null,
      editOrderForm: {
        offers: [],
      },
      formRules: {
        contractNumber: [{ required: true, validator: validateContractInput, trigger: ["blur", "change"] }],
        releaseNumber: [{ required: true, validator: validateContractInput, trigger: ["blur", "change"] }],
      },
    };
  },
  computed: {
    ...mapGetters("itemRemoval", ["showItemRemovalConfirmation", "unsavedChangesRemovalConfirmed"]),
    ...mapGetters("login", ["isGenerateOrderNumbersEnabled"]),
    hasChangeOccured() {
      return !isEqual(this.unmodifiedOrderData, this.orderData);
    },
    getOffers() {
      if (!isEmpty(this.orderData)) {
        return this.orderData.filter((order) => !order.lineItemCancelled);
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.unmodifiedOrderData = JSON.parse(JSON.stringify(this.orderToUpdate));
    this.unmodifiedOrderData.forEach((element) => {
      (element.contractNumber = element.contractNumber ? element.contractNumber : null),
        (element.releaseNumber = element.releaseNumber ? element.releaseNumber : null),
        (element.movementNumber = element.movementNumber ? element.movementNumber : null);
    });
    this.orderData = JSON.parse(JSON.stringify(this.unmodifiedOrderData));
    if (this.isGenerateOrderNumbersEnabled) {
      this.assignContractNumbersAutomatically();
    }
  },
  methods: {
    toggleSelection($event) {
      if ($event.target.checked) {
        this.selectedOffers = [];
        this.orderData.forEach((order) => {
          this.selectedOffers.push(order.orderId);
        });
      } else {
        this.selectedOffers = [];
      }
    },
    async assignContractNumbersAutomatically() {
      const currentOrder = await this.axios.get(`/api/orders/${this.orderId}`);
      if (currentOrder && currentOrder.data && currentOrder.data.status === "CONFIRMED") {
        this.errorMessageOnSave = "Order has been confirmed and assigned a contract number. Please refresh this page.";
      } else {
        const contractNumber = await this.generateContractNumber();
        for (const order of this.orderData) {
          order.contractNumber = contractNumber;
        }
      }
    },
    async generateContractNumber() {
      const contractNumberResponse = await this.axios.get("/api/contractNumber");
      const {
        data: {
          payload: { contractNumber = "" },
        },
      } = contractNumberResponse;
      return contractNumber;
    },
    async generateReleaseNumber() {
      const releaseNumberResponse = await this.axios.get("/api/releaseNumber");
      const {
        data: {
          payload: { releaseNumber = "" },
        },
      } = releaseNumberResponse;
      for (const order of this.orderData) {
        if (this.selectedOffers.includes(order.orderId)) {
          order.releaseNumber = releaseNumber;
        }
      }
      this.selectedOffers = [];
    },
    showRemovalConfirmation: function (isOpening) {
      if (isOpening) {
        this.isModalVisible = false;
        // Show removal confirmation modal
        const payload = {
          item: {},
          type: this.$store.getters["itemRemoval/eRemoveItemType"].UnconfirmedChanges,
          showWindow: true,
        };
        this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
        setTimeout(() => {
          const removalModal = this.$root.$refs.confirmationRemoveItem.$el;
          $(removalModal).modal({ show: true, keyboard: false });
        }, 250);
      }
    },
    displayPreviousModal() {
      this.isModalVisible = false;
      setTimeout(() => {
        if (this.isComingFromOrderCapture) {
          this.$emit("closeEditOrderDialog");
        } else {
          this.$emit("update:viewEditOrderDialogVisible", true);
          this.$emit("update:viewManageOrderNumbersDialog", false);
        }
      }, 150);
    },
    cancelSave() {
      if (this.hasChangeOccured) {
        this.showRemovalConfirmation(true);
      } else {
        this.displayPreviousModal();
      }
    },
    generateOrderNumbersObject() {
      this.editOrderForm.offers = this.orderData.map(({ offerId, contractNumber, releaseNumber, movementNumber }) => {
        return {
          _id: offerId,
          contractNumber,
          releaseNumber,
          movementNumber,
        };
      });
    },
    async validateForm(formName) {
      return new Promise((res) => {
        this.$refs[formName].validate((valid) => {
          return res(valid);
        });
      });
    },
    async confirmSave() {
      let formValid = this.isGenerateOrderNumbersEnabled ? await this.validateForm("form") : true;
      if (formValid) {
        this.btnLoading = true;
        await this.generateOrderNumbersObject();
        const orderDto = { offers: this.editOrderForm.offers };
        try {
          await updateOrderNumbers(this.orderId, orderDto);
          const response = await updateOrderStatus(this.orderId, {
            status: "CONFIRMED",
            feedback: this.customerFeedback,
          });
          this.handleResponse(response);
        } catch (ex) {
          let errorMessage =
            "An error occurred while confirming the order. Please try again later or contact us if the issue persists.";
          if (
            ex &&
            ex.response &&
            ex.response.data &&
            ex.response.data.errorContext &&
            ex.response.data.errorContext.id === "CONTRACT_NUMBER_ALREADY_ASSIGNED"
          ) {
            errorMessage = "Order has been confirmed and assigned a contract number. Please refresh this page.";
          }
          this.errorMessageOnSave = errorMessage;
          this.btnLoading = false;
        }
      }
    },
    handleResponse(res) {
      if (res.status === 200) {
        this.btnLoading = false;
        this.$emit("closeEditOrderDialog");
      } else {
        this.displayPreviousModal();
      }
    },
    tableHeaderClass() {
      return "dark-header-row";
    },
  },
};
</script>
<style>
.el-dialog__body {
  padding-top: 10px;
}

.el-form--label-top .el-form-item__label {
  padding: 0px !important;
}
</style>
